import React from 'react';
import classnames from 'classnames';

import { Translations } from '../../../utils';
import './AutoCompleteTextBox.css';

class AutoCompleteTextBox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      inputInValid: undefined,
      validationMsg: '',
    };
  }

  componentDidMount() {
    this.setState({ inputValue: this.props._value || '' });
    this.props.mandatory === "true" && (this.props._value !== "" || this.props._value !== undefined)
      ? this.props.setFieldValidtionState(this.props.name, "invalid") : '';
  }

  componentWillReceiveProps(nextProps) {
    if (this.props._value !== nextProps._value) {
      this.setState({ inputValue: nextProps._value })
      this.validateInput(nextProps._value, nextProps.name);
    }
  }

  handleInputChange = (e) => {
    this.props.filterList(e);
    this.setState({ inputValue: e.target.value });
    this.validateInput(e.target.value, e.target.name);
    this.props.setInputvalue(e.target.value, e.target.name);
  }

  setInputAsValid = (fieldName) => {
    this.setState({ inputInValid: false });
    this.props.setFieldValidtionState(fieldName, "valid");
  }

  setInputAsInValid = (fieldName, validationMsg) => {
    this.setState({ inputInValid: true, validationMsg });
    this.props.setFieldValidtionState(fieldName, "invalid");
  }

  setSelectedOptions(event, entity, name) {
    this.props.setSelectedOptions(event, entity, name)
  }

  validateInput = (value, name) => {

    // mandatory validation for input when set mandatory
    if (this.props.mandatory === "true") {
      // basic input validation
      if (value !== "") {
        this.setInputAsValid(name);
      } else {
        this.setInputAsInValid(name, this.props.mandatoryMessage);
      }
    }
  }


  render() {
    const options = (
      <List
        role="option"
        tabIndex="0"
        name={this.props.name}
        items={this.props.options}
        _setSelectedOptions={(event, entity) => this.setSelectedOptions(event, entity, this.props.name)}
        aria-selected="true"
      />
    );
    const inputErrorCss = classnames({
      "gdocs-input-error": this.state.inputInValid
    });

    return (
      <div>
        <input
          type="text"
          name={this.props.name}
          maxLength="60"
          id={this.props.name}
          className={inputErrorCss}
          autoComplete="off"
          onFocus={this.props.displayOptions}
          onChange={this.handleInputChange}
          value={this.state.inputValue}
        />
        <div style={{ border: 'white' }} id={this.props.name} className="admin-searchList" role="dropdown">
          {this.props.showOptions ? options : ''}
        </div>

        {
          this.state.inputInValid ? (
            <div className="input-error-msg-section">
              <span className="icon icon-circle-delete-solid"></span>{Translations(this.state.validationMsg, this.props.lang, this.props.translatedData)}
            </div>
          ) : ''
        }
      </div>
    )
  }
}

const List = (props) => (
  <div className={"listContent"} id="setList">
    {
      props.items.map((item, index) => (
        <div className={"listdata"} key={index}>
          <div className={"searchListdata"}
            data-category={item.status}
            tabIndex="0"
            onClick={(event) => props._setSelectedOptions(event, item)}
          >
            {item.name}
          </div>
          <div className="divide"></div>
        </div>
      ))
    }
  </div>
)

export default AutoCompleteTextBox;



// WEBPACK FOOTER //
// ./src/components/common/AutoCompleteTextBox/AutoCompleteTextBox.js